<div class="cards-mobile">
  <eds-panel
    [theme]="'white'"
    edsSpacing="md"
    [hasBorders]="true"
    [hasBorderRadius]="true"
    [overflowHidden]="true"
    *ngIf="cardData"
  >
    <ng-container
      [ngTemplateOutlet]="infoItemBlock"
      [ngTemplateOutletContext]="{
        cardDataDetails,
        expanded
      }"
    >
    </ng-container>
  </eds-panel>
</div>

<!-- info item for mobile display card -->
<ng-template #infoItemBlock let-cardDataDetails="cardDataDetails">
  <div class="cards-mobile__wrapper">
    <div class="cards-mobile__highlight-wrapper">
      <ng-container
        *ngFor="let rowData of cardDataDetails.expandedItems"
        [ngTemplateOutlet]="cardItem"
        [ngTemplateOutletContext]="{rowData}"
      ></ng-container>
    </div>
  </div>
  <ng-container *ngIf="expanded">
    <div class="cards-mobile__wrapper">
      <div class="cards-mobile__highlight-wrapper">
        <ng-container
          *ngFor="let rowData of cardDataDetails.collapsedItems"
          [ngTemplateOutlet]="cardItem"
          [ngTemplateOutletContext]="{rowData}"
        ></ng-container>
      </div>
    </div>
  </ng-container>
  <div
    edsPadding
    edsPaddingRight="md"
    edsPaddingLeft="sm"
    edsPaddingTop="sm"
    edsPaddingBottom="md"
  >
    <button
      [edsButton]="'icon-only'"
      [size]="'small'"
      [hasIcon]="true"
      (click)="expandDetails()"
    >
      <ng-container *ngIf="!expanded">
        <eds-icon type="carrot-down" size="small"></eds-icon>
        <span edsPadding edsPaddingLeft="sm">
          {{ "products.fund-cmp-more-details" | translate }}
        </span>
      </ng-container>

      <ng-container *ngIf="expanded">
        <eds-icon type="carrot-up" size="small"></eds-icon>
        <span edsPadding edsPaddingLeft="sm">
          {{ "products.fund-cmp-less-details" | translate }}
        </span>
      </ng-container>
    </button>
  </div>
</ng-template>
<ng-template #cardItem let-rowData="rowData">
  <eds-title
    size="h6"
    [level]="1"
    [isLight]="true"
    *ngIf="rowData.title"
    edsPadding
    edsPaddingTop="md"
    edsPaddingBottom="md"
  >
    {{ rowData.title }}
  </eds-title>
  <div [class.cards-mobile__highlight]="rowData.highlight">
    <eds-info-item
      [info]="rowData.info"
      *ngIf="rowData"
      edsPadding
      [edsPaddingTop]="rowData.highlight ? 'none' : 'xs'"
      [edsPaddingBottom]="rowData.highlight ? 'sm' : 'xs'"
      [edsPaddingLeft]="rowData.highlight ? 'none' : 'sm'"
      [edsPaddingRight]="rowData.highlight ? 'none' : 'sm'"
    >
    </eds-info-item>
  </div>
</ng-template>
